import { render } from "./CandidatePreviewCard.vue?vue&type=template&id=d73d71b2&scoped=true"
import script from "./CandidatePreviewCard.vue?vue&type=script&lang=js"
export * from "./CandidatePreviewCard.vue?vue&type=script&lang=js"

import "./CandidatePreviewCard.vue?vue&type=style&index=0&id=d73d71b2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d73d71b2"]])

export default __exports__